module.exports = __webpack_public_path__ + "img/Vector.5be36417.svg";